/**
 * Application bootstrap entrypoint.
 *
 * Responsibilities:
 * - Enable Angular production mode when configured.
 * - Apply the favicon for the current environment.
 * - Bootstrap the root `AppModule`.
 * - Surface bootstrap failures to the console for diagnostics.
 */
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { applyEnvironmentFavicon } from './app/utils/favicon.util';
import { environment } from './environments/environment';

// Disable Angular dev mode assertions and extra checks in production builds.
if (environment.production) {
  enableProdMode();
}

// Swap the tab icon so local, dev, and UAT are distinguishable from production at a glance.
applyEnvironmentFavicon(environment.faviconPath);

// Start the Angular application.
platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
